module.exports = __webpack_public_path__ + "img/00048.2da0afc0.webp";